{
  "addOffice": "Add another office",
  "completionHint": "Reuse these answers for another location. Each office gets its own agreement.",
  "editingTitle": "Another office",
  "editingHint": "Update this location's details, then review its agreement. Your signature is carried over for the same signer; consent is required again.",
  "replaceHint": "Click a carried-over text field to replace it. Leave without typing to keep the previous answer.",
  "reviewOffice": "Review this office",
  "previousDocuments": "Previous office documents",
  "duplicateTitle": "Address already used",
  "duplicateHint": "This location was already submitted in this tab. Update the address or suite for the next office, or confirm that another application for this address is intentional.",
  "duplicateConfirm": "I intend to submit another application for this address.",
  "startError": "The next application couldn't be opened. Your completed document is still available. Try again.",
  "sessionReady": "Your previous answers are ready to update for this office. Review every section before signing.",
  "previewHint": "Preview only: these answers are carried over locally. Nothing is saved or signed."
}
